import { useMutation } from '@tanstack/react-query';

import { env } from '@/config/env';
import { type AccessoryOrderInput, type AccessoryOrderReceipt } from '@/services/accessoryOrders';
import * as supabaseSource from '@/services/accessoryOrders/accessoryOrders.api';

const source = (): Promise<{
  submitAccessoryOrder: (i: AccessoryOrderInput) => Promise<AccessoryOrderReceipt>;
}> => (env.useMockData ? import('@/services/accessoryOrders/mock') : Promise.resolve(supabaseSource));

/** One submission per checkout; retry is off so a failed send is never silently repeated. */
export function useSubmitAccessoryOrder() {
  return useMutation({
    mutationFn: async (input: AccessoryOrderInput) => (await source()).submitAccessoryOrder(input),
    retry: 0,
  });
}
